import moment from 'moment-timezone';
import { storageSession } from '@klondpay/utils';
const offset = sessionStorage.getItem('offset');

export function convertTime(serviceDateTimeZone) {
  if (!serviceDateTimeZone) return '/';
  if (serviceDateTimeZone.indexOf('T') == -1) return serviceDateTimeZone;
  const offset = sessionStorage.getItem('offset');
  const timeZoneNow = sessionStorage.getItem('timeZone');
  const date = new Date(serviceDateTimeZone);
  const timeZone = timeZoneNow || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const newDate = moment.tz(date, timeZone);
  return `${newDate.format('YYYY-MM-DD HH:mm:ss')}`;
}

export function convertSubmitTime(submitTime) {
  const offsetNew = sessionStorage.getItem('offset');
  // console.log("offsetNew", offsetNew);
  if (!submitTime) return '';
  if (submitTime.length === 19) {
    submitTime = submitTime.replace(' ', 'T');
    submitTime += offsetNew;
  }
  return submitTime;
}

// 时区时间转换函数
export function convertToTimezone() {
  const offset = sessionStorage.getItem('offset');
  const acqDay = sessionStorage.getItem('acqDay');
  if (offset?.length !== 5) return;
  const now = new Date();
  const utcTime = now.getTime() + now.getTimezoneOffset() * 60000;

  const sign = offset[0] === '+' ? 1 : -1;
  const hours = parseInt(offset.substring(1, 3), 10);
  const minutes = parseInt(offset.substring(3, 5), 10);
  const offsetInMinutes = sign * (hours * 60 + minutes);

  const targetTime = utcTime + offsetInMinutes * 60000;
  const targetDate = new Date(targetTime);

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');
  const hoursStr = String(targetDate.getHours()).padStart(2, '0');
  const minutesStr = String(targetDate.getMinutes()).padStart(2, '0');
  const secondsStr = String(targetDate.getSeconds()).padStart(2, '0');

  // console.log('=',`${year}-${month}-${day} ${hoursStr}:${minutesStr}:${secondsStr}`);

  const back = {
    day: `${year}-${month}-${day}`,
    time: `${hoursStr}:${minutesStr}:${secondsStr}`,
    week: getWeekday(`${year}-${month}-${day}`),
  };
  if (acqDay !== back?.day) {
    storageSession.setItem('acqDay', back?.day);
  }
  return back;
  // console.log("back", back);
}

function getWeekday(dateString) {
  // console.log('dateString',dateString);

  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return '';

  const parts = dateString.split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  if (month < 1 || month > 12 || day < 1 || day > 31) return '';
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return '';
  }
  const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  return weekdays[date.getDay()];
}
